import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicalRecordsComponent } from './medical-records.component';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';



@NgModule({
  declarations: [MedicalRecordsComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatPaginatorModule
  ],
  exports: [MedicalRecordsComponent]
})
export class MedicalRecordsModule { }
